/* External packages */
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from './services/data.service';
import { FormsModule } from '@angular/forms';
import { StarRatingModule } from 'angular-star-rating';
import { ChartsModule } from 'ng2-charts';
import { SweetAlert2Module } from '@toverux/ngx-sweetalert2';
import { LoadingModule, ANIMATION_TYPES } from 'ngx-loading';
import { NgClass } from '@angular/common';
import { ClipboardModule } from 'ngx-clipboard';
import { BarcodeModule } from './barcode/barcode.module';
import { HttpModule } from '@angular/http';
import { ShareButtonsModule } from 'ngx-sharebuttons';
import { SocialLoginModule, AuthServiceConfig, FacebookLoginProvider, AuthService } from 'ng4-social-login';

/* Services */
import { HttpService } from './services/http.service';
import { FrontEndService } from './services/front-end.service';
import { ApiService } from './services/api.service';
import { LogService } from './services/log.service';


/* Custom components */
import { AppComponent } from './app.component';
import { HeaderComponent } from './components/header/header.component';
import { HomeComponent } from './components/home/home.component';
import { IntroWithBannerComponent } from './components/intro-with-banner/intro-with-banner.component';
import { CopyRightComponent } from './components/copy-right/copy-right.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { UIRouterModule } from '@uirouter/angular';
import { LandingPageComponent } from './components/landing-page/landing-page.component';
import { AppHeaderComponent } from './components/app-header/app-header.component';
import { WelcomeProfileComponent } from './components/welcome-profile/welcome-profile.component';
import { DashboardNotificationsComponent } from './components/dashboard-notifications/dashboard-notifications.component';
import { SidebarmenuComponent } from './components/sidebarmenu/sidebarmenu.component';
import { HttpClientModule, HttpClientJsonpModule } from '@angular/common/http';
import { ContactComponent } from './components/contact/contact.component';
import { AboutComponent } from './components/about/about.component';
import { LoginSignupComponent } from './components/login-signup/login-signup.component';
import { ToastyModule } from 'ng2-toasty';
import { LoginPopupComponent } from './components/login-popup/login-popup.component';
import { ProfileComponent } from './components/profile/profile.component';
import { UserprofileComponent } from './components/userprofile/userprofile.component';
import { CountryModalComponent } from './components/country-modal/country-modal.component';
import { ReportComponent } from './components/report/report.component';
import { ReportfakeComponent } from './components/reportfake/reportfake.component';
import { VerificationpopupComponent } from './components/verificationpopup/verificationpopup.component';
import { SendFeebackComponent } from './components/send-feeback/send-feeback.component';
import { ForgotPopupComponent } from './components/forgot-popup/forgot-popup.component';
import { ReviewsComponent } from './components/reviews/reviews.component';
import { SelectCurrencyComponent } from './components/select-currency/select-currency.component';
import { VerifyProductComponent } from './components/verify-product/verify-product.component';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { TermsConditionComponent } from './components/terms-condition/terms-condition.component';
import { TransactionHistoryComponent } from './components/transaction-history/transaction-history.component';
import { VerifyCouponComponent } from './components/verify-coupon/verify-coupon.component';
import { FilterComponent } from './components/filter/filter.component';
import { DownloadComponent } from './components/download/download.component';
import { FilterPipe } from './filter.pipe';
import { RedeemCouponComponent } from './components/redeem-coupon/redeem-coupon.component';
import { FooterComponent } from './components/footer/footer.component';
import { ProvideProductDetailComponent } from './components/provide-product-detail/provide-product-detail.component';
import { PreCheckProductComponent } from './components/pre-check-product/pre-check-product.component';
import { InfoPanelComponent } from './components/info-panel/info-panel.component';
import { SelectCameraModeTypeComponent } from './components/select-camera-mode-type/select-camera-mode-type.component';
import { VerifyProductModalComponent } from './components/verify-product-modal/verify-product-modal.component';
import { ShareModalComponent } from './components/share-modal/share-modal.component';

import { ForbiddenComponent } from './components/forbidden/forbidden.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { FocusDirective } from './directives/focus.directive';


const HeaderState = { name: 'header', url: '/header',  component: HeaderComponent };
const landingState = { name: 'landing', url: '/',  component: LandingPageComponent };
const dashboardState = { name: 'dashboard', url: '/dashboard',  component: DashboardComponent };
const contactState = { name: 'contact', url: '/contact', component: ContactComponent };
const aboutState = { name: 'about', url: '/about', component: AboutComponent };
const profileState = { name: 'profile', url: '/profile', component: ProfileComponent };
const transactionHistoryState = { name: 'transactionHistory', url: '/transaction-history', component: TransactionHistoryComponent };
const verifyProductState = { name: 'verifyProduct', url: '/verify-product', component: VerifyProductComponent };
const couponProductState = { name: 'couponProduct', url: '/coupon-product', component: VerifyCouponComponent };
const redeemCouponState = { name: 'redeemCoupon', url: '/redeem-coupon', component: RedeemCouponComponent };
const preCheckProductState = { name: 'preCheck', url: '/precheck-product', component: PreCheckProductComponent };

const sendFeedbackState = { name: 'sendFeeback', url: '/feedback', component: SendFeebackComponent };
const reportFakeProductState = { name: 'reportFake', url: '/report-fake-product', component: ReportfakeComponent };
const reportState = { name: 'reportIncident', url: '/report-incident', component: ReportComponent };
const privacyState = { name: 'privacyPolicy', url: '/privacy-policy', component: PrivacyPolicyComponent };
const termsConditionState = { name: 'termsCondition', url: '/terms-condition', component: TermsConditionComponent };

const notFoundState = { name: '404', url: '/404', component: NotFoundComponent };
const ForbiddenComponentState = { name: 'forbidden', url: '/forbidden', component: ForbiddenComponent };


const CONFIG = new AuthServiceConfig([
  {
    id: FacebookLoginProvider.PROVIDER_ID,
    provider: new FacebookLoginProvider('165202937463001')
  }
]);

export function provideConfig() {
  return CONFIG;
}


@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    HomeComponent,
    IntroWithBannerComponent,
    CopyRightComponent,
    DashboardComponent,
    LandingPageComponent,
    AppHeaderComponent,
    WelcomeProfileComponent,
    DashboardNotificationsComponent,
    SidebarmenuComponent,
    ContactComponent,
    AboutComponent,
    LoginSignupComponent,
    LoginPopupComponent,
    ProfileComponent,
    UserprofileComponent,
    CountryModalComponent,
    ReportComponent,
    ReportfakeComponent,
    VerificationpopupComponent,
    SendFeebackComponent,
    ForgotPopupComponent,
    // TransactionComponent,
    ReviewsComponent,
    SelectCurrencyComponent,
    VerifyProductComponent,
    PrivacyPolicyComponent,
    TermsConditionComponent,
    TransactionHistoryComponent,
    VerifyCouponComponent,
    FilterPipe,
    FilterComponent,
    DownloadComponent,
    RedeemCouponComponent,
    FooterComponent,
    ProvideProductDetailComponent,
    PreCheckProductComponent,
    FocusDirective,
    InfoPanelComponent,
    SelectCameraModeTypeComponent,
    VerifyProductModalComponent,
    ShareModalComponent,
    ForbiddenComponent,
    NotFoundComponent
    // AppModalComponent
  ],
  imports: [
    BrowserModule,
    NgbCarouselModule.forRoot(),
    NgbModule.forRoot(),
    FormsModule,
    HttpClientModule,
    HttpModule,
    HttpClientJsonpModule,
    ToastyModule.forRoot(),
    StarRatingModule.forRoot(),
    ClipboardModule,
    BarcodeModule,
    SweetAlert2Module.forRoot({
      buttonsStyling: false,
      customClass: 'modal-content',
      confirmButtonClass: 'btn btn-primary',
      cancelButtonClass: 'btn'
    }),

    ChartsModule,
    // ShareButtonsModule.forRoot({ options: options }),
    ShareButtonsModule.forRoot(),
    LoadingModule.forRoot({
      animationType: ANIMATION_TYPES.threeBounce,
      backdropBackgroundColour: 'rgba(0, 0, 0, 0.55)',
      primaryColour: '#562976',
      secondaryColour: '#562976',
      tertiaryColour: '#562976'
  }),
    UIRouterModule.forRoot({
      states: [
        landingState,
        HeaderState,
        dashboardState,
        contactState,
        aboutState,
        profileState,
        sendFeedbackState,
        reportFakeProductState,
        reportState,
        privacyState,
        termsConditionState,
        verifyProductState,
        transactionHistoryState,
        couponProductState,
        redeemCouponState,
        preCheckProductState,
        notFoundState,
        ForbiddenComponentState
      ], otherwise: '/404', useHash: false
    }),

  ],
  providers: [
    HttpService,
    FrontEndService,
    ApiService,
    AuthService,
    DataService,
    LogService,
    {
      provide: AuthServiceConfig,
      useFactory: provideConfig
    }
  ],
  bootstrap: [AppComponent]
})

export class AppModule { }



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/landing_page/src/app/app.module.ts